module.exports = __webpack_public_path__ + "assets/img/logo-krug.18990ee7.svg";